<template>
  <fo-layout class="white-bg">
    <div class="home-team">
      <a-row :gutter="20">
        <a-col :sm="6">
          <div class="title-box">
            <img class="back-logo" src="../../../static/logo1.png" alt="">
            <div class="title-bar">
              <p class="title-alt primary ta-l">{{arr.sub_title}}</p>
              <h1 class="title primary ta-l">{{arr.title}}</h1>
            </div>
            <p class="info textn to-4 pt-20">{{arr.intro}}</p>
            <div class="card-btn">
              <span class="primary cur-p" @click="goToPage(null)">View More <a-icon type="right" /></span>
            </div>
            <div class="btns-box">
              <div class="btns">
                <span class="primary-bg"
                  :class="memberCond.page_num == 1 ? 'silver-bg' : 'fo-small-btn'"
                  @click="prevHandle">
                  <a-icon type="left" /></span>
                <span class="primary-bg"
                  :class="memberCond.page_num * memberCond.page_size >= memberTotal ? 'silver-bg' : 'fo-small-btn'"
                  @click="nextHandle">
                  <a-icon type="right" /></span>
              </div>
            </div>
          </div>
        </a-col>
        <a-col :sm="18">
          <a-spin :spinning="loading">
            <a-row :gutter="30" v-if="memberData.length">
              <a-col class="card-hidden-anchor" :xs="12" :sm="8" v-for="(item, ind) in memberData" :key="ind">
                <div class="card-item-hover" @click="goToPage('./team/' + item.code)">
                  <div class="card-item">
                    <div class="mask-info">
                      <div class="info-posi">
                        <p class="to-1">
                          <span class="icon"><a-icon theme="filled" type="phone" /></span>{{item.member_phone}}</p>
                        <p class="to-1">
                          <span class="icon"><a-icon theme="filled" type="mail" /></span>{{item.member_email}}</p>
                      </div>
                    </div>
                    <div class="centerimage" :style="'background-image: url(' + item.member_avatar + ')'"></div>
                  </div>
                  <p class="member-name to-1">{{item.member_name}}</p>
                </div>
              </a-col>
            </a-row>
            <a-row :gutter="30" v-else>
              <a-col class="card-hidden-anchor" :xs="12" :sm="8" v-for="(item, ind) in 3" :key="ind">
                <div class="card-item-hover" @click="goToPage('./team/' + item.code)">
                  <div class="card-item">
                    <div class="centerimage gray-bg"></div>
                  </div>
                  <p class="member-name to-1">
                    <span class="dis-bl ht-30 gray-bg wi-120 mg-a"></span>
                  </p>
                </div>
              </a-col>
            </a-row>
          </a-spin>
        </a-col>
      </a-row>
    </div>
  </fo-layout>
</template>

<script>
export default {
  data () {
    return {
      arr: [],
      // 表格加载动画
      loading: false,
      // 保存客户数据
      memberData: [],
      // 总共多少条
      memberTotal: 0,
      // 客户查询条件
      memberCond: {
        // 第几页
        page_num: 1,
        // 每页多少条
        page_size: 3
      }
    }
  },
  mounted () {
    this.readItems()
    this.readItemList()
  },
  methods: {
    goToPage (router) {
      window.scroll(0, 0)
      if (router) {
        this.$router.push(router)
      } else {
        this.$router.push('./team')
      }
    },
    prevHandle () {
      if (this.memberCond.page_num > 1) {
        this.memberCond.page_num -= 1
        this.readItems()
      }
    },
    nextHandle () {
      if (this.memberTotal > (this.memberCond.page_num * this.memberCond.page_size)) {
        this.memberCond.page_num += 1
        this.readItems()
      }
    },
    /**
     * 页头、页脚公用信息查询
     */
    readItemList () {
      this.get({
        url: 'configFind',
        data: {
          key: 'web_pages'
        }
      }, (r) => {
        if (r.code) {
          this.arr = JSON.parse(r.data.value)[0].children[3]
        }
      })
    },
    /*
    * 查询客户
    */
    readItems () {
      this.loading = true
      this.get({
        url: 'memberRead',
        data: this.memberCond
      }, (r) => {
        this.loading = false
        if (r.code) {
          this.memberTotal = r.data.total
          this.memberData = r.data.items
        } else {
          this.error(r.msg)
        }
      })
    }
  }
}
</script>

<style lang="less">
@import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .example2 {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 280px 50px;
    margin: 20px 0;
  }
  .home-team {
    .title-box {
      height: 280px;
    }
    .card-btn {
      font-size: 16px;
      padding: 0 0 20px;
      .primary:hover {
        color: @support;
        cursor: pointer;
      }
    }
    .back-logo {
      display: none;
    }
    .btns {
      span {
        display: inline-block;
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #FFF;
        font-size: 18px;
        cursor: pointer;
        margin-right: 4px;
      }
    }
    /*.card-hidden-anchor:last-child {
      display: none;
    }*/
    .card-item {
      position: relative;
      .mask-info {
        display: none;
        width: 100%;
        height: 100%;
        background-color: rgba(1,55,124,0.6);
        color: #FFF;
        position: absolute;
        left: 0;
        top: 0;
        .info-posi {
          width: 60%;
          min-width: 210px;
          height: 50px;
          font-size: 16px;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          p {
            margin: 0;
          }
          .icon {
            color: #DBA77F;
            margin-right: 8px;
          }
        }
      }
    }
    .centerimage {
      width: 100%;
      height: 200px;
    }
    .member-name {
      font-family: Georgia, 宋体;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      margin: 10px 0 0;
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .example2 {
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 180px 50px;
    margin: 20px 0;
  }
  .home-team {
    .title-box {
      height: 400px;
    }
    .card-btn {
      margin-top: 70px;
      font-size: 16px;
      padding: 0 0 20px;
      .primary:hover {
        color: @support;
        cursor: pointer;
      }
    }
    .back-logo {
      width: 200px;
      height: 200px;
      position: absolute;
      left: -90px;
      top: -80px;
    }
    .title-bar {
      font-family: Georgia, 宋体;
      .title-alt {
        font-size: 14px;
        margin: 0;
      }
      .title {
        font-size: 46px !important;
        font-weight: bold;
        margin: 0;
      }
    }
    .btns-box {
      position: absolute;
      left: 10px;
      bottom: 0;
    }
    .btns {
      span {
        display: inline-block;
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #FFF;
        font-size: 18px;
        cursor: pointer;
        margin-right: 4px;
      }
    }
    .card-item {
      position: relative;
      .mask-info {
        display: none;
        width: 100%;
        height: 100%;
        background-color: rgba(1,55,124,0.6);
        color: #FFF;
        position: absolute;
        left: 0;
        top: 0;
        .info-posi {
          width: 60%;
          min-width: 210px;
          height: 50px;
          font-size: 16px;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
          p {
            margin: 0;
          }
          .icon {
            color: #DBA77F;
            margin-right: 8px;
          }
        }
      }
    }
    .centerimage {
      width: 100%;
      height: 400px;
    }
    .member-name {
      font-family: Georgia, 宋体;
      font-size: 26px;
      font-weight: bold;
      text-align: center;
      margin: 10px 0 0;
      opacity: 0.7;
    }
    .card-item-hover:hover {
      .mask-info {
        display: block;
        cursor: pointer;
      }
      .member-name {
        opacity: 1;
        color: @primary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/team.vue